import React from "react";
import { Table } from "react-bootstrap";

import { useRatingsContext } from "../contexts/Ratings";
import calculateRating from "../lib/calculateRating";

const OverallRatings = (): React.JSX.Element => {
    const { ratings } = useRatingsContext();

    return (
        <Table
            className="currentYearOverallRatings"
            striped
            data-testid="currentYearOverallRatings"
        >
            <tbody>
                <tr>
                    <td width={"50%"}>Head Coaching:</td>
                    <td>
                        {calculateRating({
                            ratings,
                            type: "headCoach",
                        })}
                    </td>
                </tr>
                <tr>
                    <td width={"50%"}>Asst. Coaching:</td>
                    <td>
                        {calculateRating({
                            ratings,
                            type: "asstCoach",
                        })}
                    </td>
                </tr>
                <tr>
                    <td width={"50%"}>Spectators:</td>
                    <td>
                        {calculateRating({
                            ratings,
                            type: "spectators",
                        })}
                    </td>
                </tr>
                <tr>
                    <td width={"50%"}>Overall:</td>
                    <td>
                        {calculateRating({
                            ratings,
                            type: "overall",
                        })}
                    </td>
                </tr>
            </tbody>
        </Table>
    );
};

export default OverallRatings;
